"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

exports.implementation = /*#__PURE__*/function (_Array) {
  _inherits(FileListImpl, _Array);

  function FileListImpl() {
    _classCallCheck(this, FileListImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileListImpl).call(this, 0));
  }

  _createClass(FileListImpl, [{
    key: "item",
    value: function item(index) {
      return this[index] || null;
    }
  }]);

  return FileListImpl;
}( /*#__PURE__*/_wrapNativeSuper(Array));